export default __webpack_public_path__ + "static/media/hamburger.15a29eb2.svg";